{
  "#CUSTOMER": {
    "TITLE": "Kundenabfrage",
    "NUMBER": "Kundennummer",
    "PERSON": {
      "TITLE": "Personenbezogene Daten",
      "GENDER": "Anrede",
      "FIRST_NAME": "Vorname",
      "LAST_NAME": "Nachname",
      "NAME": "Name"
    },
    "ADDRESS": {
      "TITLE": "Addresse",
      "GOOGLE_MAPS": "In 'Google Maps' öffnen",
      "STREET": "Straße",
      "NUMBER": "Hausnummer",
      "ZIP": "PLZ",
      "CITY": "Ort"
    },
    "CONTACT": {
      "TITLE": "Kontakt"
    },
    "EMAIL": {
      "TITLE": "E-Mail"
    },
    "INFO": "Bitte geben Sie eine Kundennummer ein oder wählen sie einen Kunden aus"
  }
}
